/**
 * FinOps Service — Azure Cost Intelligence
 * 
 * Consome endpoints: /api/governance/finance/finops/*
 * Usa AZURE axios instance (JWT + interceptors)
 */
import { AZURE } from './api';

const BASE = '/governance/finance/finops';

/** GET /finops/dashboard - Dashboard consolidado */
export const getFinOpsDashboard = async () => {
  const { data } = await AZURE.get(`${BASE}/dashboard`);
  return data;
};

/** GET /finops/inventory - Inventário de recursos Azure */
export const getFinOpsInventory = async (type = null) => {
  const params = type ? { type } : {};
  const { data } = await AZURE.get(`${BASE}/inventory`, { params });
  return data;
};

/** GET /finops/recommendations - Recomendações de otimização */
export const getFinOpsRecommendations = async (status = 'pending') => {
  const { data } = await AZURE.get(`${BASE}/recommendations`, { params: { status } });
  return data;
};

/** POST /finops/recommendations - Criar nova recomendação */
export const createFinOpsRecommendation = async (payload) => {
  const { data } = await AZURE.post(`${BASE}/recommendations`, payload);
  return data;
};

/** POST /finops/recommendations/:id/approve - Aprovar recomendação */
export const approveFinOpsRecommendation = async (id, approvedBy = 'admin') => {
  const { data } = await AZURE.post(`${BASE}/recommendations/${id}/approve`, { approved_by: approvedBy });
  return data;
};

/** GET /finops/cost-trend - Trend de custo mensal */
export const getFinOpsCostTrend = async (months = 6) => {
  const { data } = await AZURE.get(`${BASE}/cost-trend`, { params: { months } });
  return data;
};

/** GET /finops/rightsizing - Candidatos a downsizing */
export const getFinOpsRightsizing = async () => {
  const { data } = await AZURE.get(`${BASE}/rightsizing`);
  return data;
};

/** GET /finops/metrics/:resourceName - Métricas por recurso */
export const getFinOpsResourceMetrics = async (resourceName) => {
  const { data } = await AZURE.get(`${BASE}/metrics/${resourceName}`);
  return data;
};

/** POST /finops/collect - Trigger coleta manual */
export const triggerFinOpsCollect = async () => {
  const { data } = await AZURE.post(`${BASE}/collect`);
  return data;
};

/** GET /finops/health - Health check */
export const getFinOpsHealth = async () => {
  const { data } = await AZURE.get(`${BASE}/health`);
  return data;
};

/**
 * Gate 1 — Verdade operacional do mês.
 * GET /api/governance/finance/finops/azure/data-freshness
 * Retorna última data de usage Azure, último batch, última consolidação,
 * cobertura PTAX e itens sem classificação (timezone America/Sao_Paulo).
 */
export const getAzureDataFreshness = async () => {
  const { data } = await AZURE.get('/governance/finance/finops/azure/data-freshness');
  return data;
};

// ─────────────────────────────────────────────────────────────────────────
// Gate 4 — Azure por conta (subscription_guid = identidade técnica)
// Valores monetários vêm SERIALIZADOS do backend (strings Decimal).
// NUNCA recalcular crédito/líquido no frontend — totais oficiais são da API.
// ─────────────────────────────────────────────────────────────────────────

/** Lista o cadastro de assinaturas Azure. */
export const getAzureSubscriptions = async (params = {}) => {
  const { data } = await AZURE.get('/governance/finance/finops/azure/subscriptions', { params });
  return data;
};

/** Detalhe de uma assinatura (inclui eventos de auditoria). */
export const getAzureSubscription = async (guid) => {
  const { data } = await AZURE.get(`/governance/finance/finops/azure/subscriptions/${guid}`);
  return data;
};

/** Edição administrativa (display_name, environment, status, elegibilidade). */
export const updateAzureSubscription = async (guid, changes) => {
  const { data } = await AZURE.patch(`/governance/finance/finops/azure/subscriptions/${guid}`, changes);
  return data;
};

/** Resumo por assinatura: gross/credit/net USD+BRL, unmapped, última data. */
export const getAzureSubscriptionSummary = async (referenceMonth, params = {}) => {
  const { data } = await AZURE.get('/governance/finance/finops/azure/subscription-summary', {
    params: { reference_month: referenceMonth, ...params },
  });
  return data;
};

/** Freshness por assinatura (is_stale, latest vs complete_through). */
export const getAzureSubscriptionFreshness = async () => {
  const { data } = await AZURE.get('/governance/finance/finops/azure/subscription-freshness');
  return data;
};

/** Itens sem classificação detalhados (por assinatura/serviço/recurso). */
export const getAzureUnmappedDetail = async (params = {}) => {
  const { data } = await AZURE.get('/governance/finance/finops/azure/unmapped-detail', { params });
  return data;
};
